<template>
  <div class="matching-box clearfix">
    <vxe-form
      :data="formData"
      title-colon
      ref="xForm"
      title-width="120"
      title-align="right"
    >
      <vxe-form-item title="应付账款" field="payAmount" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2">
            {{ formData.payAmount }}
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="已付金额" field="payedAmount" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2">
            {{ formData.payedAmount }}
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="未付金额" field="unpayAmount" span="8">
        <template>
          <div class="matching-inner-box matching-inner-box-2">
            {{ formData.unpayAmount }}
          </div>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>
export default {
    props:{
        detailData: Object,
    },
    data() {
        return {
            formData: {
                payedAmount: null,
                unpayAmount: null,
                payAmount: null,
            }
        }
    },
    watch: {
    detailData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.formData.payedAmount = val.payedAmount;
          this.formData.unpayAmount = val.unpayAmount;
          this.formData.payAmount = val.payAmount;
        }
      }
    }
  },
};
</script>

<style>
</style>